import React, { useEffect, useState, useCallback } from "react";
import { motion } from "framer-motion";
import { ethers } from "ethers";
import "../../About.css";
import garetto2Abi from "../../abi/garetto2_abi.json";

const CONTRACT_ADDRESS = "0xa955e9fEecf47B7D5458Ba128D1EE46568373b41";

const RPCS = [
  "https://api.avax.network/ext/bc/C/rpc",
  "https://rpc.ankr.com/avalanche",
  "https://avalanche.public-rpc.com",
];
export default function GettoGlobal() {
  const [transfers, setTransfers] = useState("0");
  const [price, setPrice] = useState(null);
  const TokenLogo = ({ size = 12 }) => (
    <img
      src="/logo.svg"
      alt="token logo"
      style={{
        width: `${size}px`,
        verticalAlign: "middle",
        marginLeft: "3px",
      }}
    />
  );
  // ✅ provider
  const getProvider = useCallback(async () => {
    for (const url of RPCS) {
      const p = new ethers.JsonRpcProvider(url);
      try {
        await p.getBlockNumber();
        return p;
      } catch {}
    }
    throw new Error("No RPC available");
  }, []);

  // ✅ transfers
  const loadTransfers = useCallback(async () => {
    try {
      const provider = await getProvider();
      const contract = new ethers.Contract(
        CONTRACT_ADDRESS,
        garetto2Abi,
        provider,
      );

      const t = await contract.transfersCount();
      setTransfers(t.toString());
    } catch (e) {
      console.warn("Transfers load failed", e);
    }
  }, [getProvider]);

  // ✅ price
  const loadPrice = useCallback(async () => {
    try {
      const res = await fetch(
        "https://api.dexscreener.com/latest/dex/tokens/0x76938525d4ED7D0b22a899d8bDc1bEF57cd47D18",
      );
      const data = await res.json();

      if (data.pairs && data.pairs.length > 0) {
        setPrice(data.pairs[0].priceUsd);
      }
    } catch (e) {
      console.warn("Price load failed", e);
    }
  }, []);

  // ✅ effect (NO WARNINGS NOW)
  useEffect(() => {
    loadTransfers();
    loadPrice();

    const interval = setInterval(() => {
      loadTransfers();
      loadPrice();
    }, 10000);

    return () => clearInterval(interval);
  }, [loadTransfers, loadPrice]);

  return (
    <div className="about-container">
      <div className="about-wrapper">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4 }}
          className="global-item"
        >
          <div className="global-content">
            <div className="global-content1">
              <h4 className="global-title">
                <TokenLogo size={20} /> Garetto (G-ETTO) on Avalanche
              </h4>

              <p>
                <a
                  href="https://snowtrace.io/address/0x76938525d4ED7D0b22a899d8bDc1bEF57cd47D18"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    wordBreak: "break-all",
                    overflowWrap: "break-word",
                  }}
                >
                  0x76938525d4ED7D0b22a899d8bDc1bEF57cd47D18
                </a>
              </p>
              <h4 className="global-title">Redistributor Contract</h4>

              <p>
                <a
                  href="https://snowtrace.io/address/0xa955e9fEecf47B7D5458Ba128D1EE46568373b41"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    wordBreak: "break-all",
                    overflowWrap: "break-word",
                  }}
                >
                  0xa955e9fEecf47B7D5458Ba128D1EE46568373b41
                </a>
              </p>
              <div className="gambleHeaderRow">
                <div className="gambleRow">
                  <h5>Total Supply:</h5>
                </div>

                <div className="gambleRow">
                  <h5>
                    {" "}
                    100.000.000
                    <TokenLogo size={16} />
                  </h5>
                </div>
              </div>
              <div className="gambleHeaderRow">
                <div className="gambleRow">
                  <h5>Token Price:</h5>
                </div>

                <div className="gambleRow">
                  <h5>
                    1<TokenLogo size={15} /> ={" "}
                    {price ? `$${Number(price).toFixed(8)}` : "Loading..."}
                  </h5>
                </div>
              </div>
              <div className="gambleHeaderRow">
                <div className="gambleRow">
                  <h5 title="The minimum transfer amount can be modified from 1 to 0.001">
                    Min Transfer Amount:
                  </h5>
                </div>

                <div className="gambleRow">
                  <h5>
                    1
                    <TokenLogo size={15} />
                  </h5>
                </div>
              </div>
              <div className="gambleHeaderRow">
                <div className="gambleRow">
                  <h5>Global Transfers Count:</h5>
                </div>

                <div className="gambleRow">
                  <h5>{transfers}</h5>
                </div>
              </div>
            </div>
            <div className="global-content1">
              <p>
                A fixed 0.1% fee from every transaction is automatically routed
                to the Redistributor contract. On every incoming transaction,
                the contract generates three random numbers using Chainlink VRF.
                These numbers are evaluated against predefined rules. When
                conditions are satisfied, a redistribution event is triggered,
                and a percentage of the reserve is paid out to the transaction
                sender. Redistributions during conditions 1, 2, and 3 do not
                reset the transfers counter. After a successful redistribution
                in these conditions the reserve is reduced by the corresponding
                payout percentage. The winning wallet receives the redistributed
                amount. The transfers counter continues increasing from its
                current value. The cycle ID increased after every
                redistribution. Only after successful redistribution during
                condition 4 the transfers counter is reset to zero.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  );
}
